import { render, staticRenderFns } from "./CashbankSummary.vue?vue&type=template&id=5b083f3c"
import script from "./CashbankSummary.vue?vue&type=script&lang=js"
export * from "./CashbankSummary.vue?vue&type=script&lang=js"
import style0 from "./CashbankSummary.vue?vue&type=style&index=0&id=5b083f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports